import React from 'react';
import { observer } from 'mobx-react';
import { TriviaHomeWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import { TreeUI, AppUI } from '@seedlang/state';
import Module from 'components/module';
import TriviaDeckLink from 'components/trivia/trivia_deck_link';
import LearnLayout from 'pages/main/learn_layout';
import TriviaProgress from 'components/trivia/trivia_progress';
import Spinner from 'components/spinner';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const DeckRow = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  height: 300px;
  padding: ${props => props.isMobile ? 0 : '0 10px 0 0'};
`;

const InnerDeckRow = styled.div`
  display: flex;
  position: absolute;
  width: ${props => props.isMobile ? '100%' : 'calc(100% - 20px)'};
  overflow: auto;
  height: 300px;
  align-items: center;
  padding: 0 0 0 20px;
  box-sizing: ${props => props.isMobile ? 'border-box' : null};
`;

@observer
class TriviaHome extends React.Component {
  render() {
    return (
      <LearnLayout>
        <Wrapper>
          {
            !TreeUI.triviaTree &&
              <Spinner />
          }
          {
            TreeUI.triviaTree && TreeUI.triviaTree.treeModules.map(treeModule => {
              if (treeModule.webPublished || AppUI.user.admin) {
                return (
                  <Module
                    key={treeModule.id}
                    title={treeModule.name}
                    slug={treeModule.id}
                    disableToggle
                  >
                      {
                        treeModule.treeRows.map(treeRow => {
                          return (
                            <DeckRow
                              key={treeRow.id}
                              isMobile={AppUI.layout.isMobile}
                            >
                              <InnerDeckRow
                                isMobile={AppUI.layout.isMobile}
                              >
                                {
                                  treeRow.treeNodes.map(treeNode => {
                                    const userTreeNode = AppUI.userTreeNodeStore.indexData.find(item => item.treeNodeId === treeNode.id);
                                    if (treeNode.webPublished || AppUI.user.admin) {
                                      return (
                                        <TriviaDeckLink
                                          key={treeNode.id}
                                          treeNode={treeNode}
                                          userTreeNode={userTreeNode}
                                          marginRight='10px'
                                          showFirstOpenTriviaModal
                                        />
                                      );
                                    } else {
                                      return null;
                                    }
                                  })
                                }
                              </InnerDeckRow>
                            </DeckRow>
                          );
                        })
                      }
                  </Module>
                );
              } else {
                return <span />;
              }
            })
          }
        </Wrapper>
        <TriviaProgress />
      </LearnLayout>
    );
  }
}

export default TriviaHomeWrapper(TriviaHome);
